/**
 * Vendor Bills container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import vendorBillActions from './actions';
import VendorBills from '../../Components/VendorBills/VendorBills';
import {
  countSelector,
  loadingSelector,
  vendorBillsSelector,
} from './selectors';
import { vendorSelector } from '../VendorApplication/selectors';

const { getVendorBills } = vendorBillActions;

/**
 * Properties to be provided to the vendor bills component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  vendorBills: vendorBillsSelector(state),
  loading: loadingSelector(state),
  count: countSelector(state),
  vendor: vendorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch vendor bills actions
 */
const mapDispatchToProps = (dispatch) => ({
  getVendorBills: (user, params) => dispatch(getVendorBills(user, params)),
});

/**
 * Connects state to the Vendor Bill component
 *
 * @param {object} mapStateToProps data object to become props for the Vendor Bill component
 * @param {object} mapDispatchToProps Vendor Bill actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(VendorBills),
);
